<template>
 <login-layout>
  <div class="center-btn">
    <p v-if="$whitelabel" class="text-center m-t-xl m-b-lg get-started-contact">For all support enquiries relating to {{ clientName }} please call us on {{ contactNumber }} or email us at <a :href="'mailto:' + contactEmail">{{ contactEmail }}</a></p>
    <p v-else class="text-center m-t-xl m-b-lg get-started-contact">For all support enquiries relating to {{ clientName }} please call us on {{ contactNumber }} or email us at <a :href="'mailto:' + contactEmail">{{ contactEmail }}</a></p>
    <div class="flex w-full justify-center">
      <router-link to="/login"
       tag="button"
       ref="back"
       class="btn btn-dark"
       type="submit">
        Return to Login
      </router-link>
    </div>
  </div>
</login-layout>
</template>

<script>
import LoginLayout from './auth/LoginLayout'

export default {
  components: {
    LoginLayout
  }

}
</script>
